import React from 'react';
import style from './PrimaryButton.module.css';
import spinner from '../../assets/Spinner.svg';

const PrimaryButton = ({ text, click, disabled, loading, width, type = 'button' }) => {
	const buttonStyle = width ? { width } : undefined;

	return (
		<button
			className={style.PrimaryButton}
			onClick={click}
			disabled={disabled || loading}
			style={buttonStyle}
			type={type}
		>
			{loading ? (
				<img src={spinner} alt="Loading" className={style.spinner} />
			) : (
				<span>{text}</span>
			)}
		</button>
	);
};

export default PrimaryButton;
